<template>
  <v-card outlined class="pa-4" width="100%">
    <v-text-field :disabled="!canWrite || hasMultipleActiveWatchers" class="mt-2" data-testid="voicemails-settings-account-email" v-model="email"
      prepend-inner-icon="mdi-email"
      :rules="[rules.email]"
      filled
      :label="$t('vmail.cfg.settings.email')"
      style="min-width: 250px"
    >
      <template v-slot:append-outer>
        <cp-help i18n="vm.email" />
      </template>
    </v-text-field>
    <v-text-field :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-account-pager" v-model="pager"
      prepend-inner-icon="mdi-message-text"
      :rules="[rules.pager]"
      filled
      style="min-width: 250px"
      :label="$t('vmail.cfg.settings.pager')"
    >
      <template v-slot:append-outer>
        <cp-help i18n="vm.pager" />
      </template>
    </v-text-field>
    <v-text-field :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-account-pin" v-model="pin"
      :append-icon="showPin ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPin ? 'text' : 'password'"
      autocomplete="off"
      @click:append="showPin = !showPin"
      prepend-inner-icon="mdi-lock"
      :rules="[rules.pin]"
      filled
      style="min-width: 250px"
      :label="$t('vmail.cfg.settings.pin')"
    >
      <template v-slot:append-outer>
        <cp-help i18n="vm.pin" />
      </template>
    </v-text-field>
    <v-card-actions>
      <v-btn data-testid="voicemails-settings-account-save-btn" @click="save" :disabled="!readyToSave">
        {{ $t('vmail.cfg.btnSave') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'voicemail-settings-general-account',
  data () {
    return {
      showPin: false,
      rules: {
        email: this.validEmail,
        pager: this.validPager,
        pin: this.validPin
      }
    }
  },
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings',
      currentUserID: 'settings/userID',
      vmboxWriteFor: 'permissions/vmboxWriteFor',
      canWriteCurrentUser: 'permissions/vmboxesWrite',
      vmWatcherBoxID: 'voicemails/watcherBoxID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      vmWatcherUserID: 'voicemails/watcherUserID',
      pinRestrictions: 'voicemails/pinRestrictions',
      activeWatchers: 'voicemails/activeWatchers'
    }),
    canWrite: function () {
      if (this.activeWatchers.length > 1) {
        return false
      }
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.canWriteCurrentUser
      }
      return this.vmboxWriteFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    readyToSave: function () {
      return (
        this.canWrite === true &&
        this.validEmail(this.email) === true &&
        this.validPager(this.pager) === true &&
        this.validPin(this.pin) === true
      )
    },
    email: {
      get: function () {
        return this.vmbox.email
      },
      set: function (value) {
        this.setEmail(value)
      }
    },
    pager: {
      get: function () {
        return this.vmbox.pager
      },
      set: function (value) {
        this.setPager(value)
      }
    },
    pin: {
      get: function () {
        return this.vmbox.pin
      },
      set: function (value) {
        this.setPin(value)
      }
    }
  },
  methods: {
    ...mapActions({
      setEmail: 'voicemails/setVBEmail',
      setPager: 'voicemails/setVBPager',
      setPin: 'voicemails/setVBPin',
      saveSettings: 'voicemails/saveSettings'
    }),
    save () {
      if (!this.readyToSave) {
        return
      }
      this.saveSettings()
    },
    validEmail: function (email) {
      if (!email || email.length === 0) {
        return true // ignore empty values
      }
      if (typeof email !== 'string') {
        return this.$t('vmail.cfg.err.email')
      }
      for (const emailValue of email.split(',')) {
        // naive regex to check whether value is an email
        if (!/^[^@\s]+@([_\d\w-]+\.)+[\w\d]{2,}$/.test(emailValue.trim())) {
          return this.$t('vmail.cfg.err.email')
        }
      }
      return true
    },
    validPager: function (pager) {
      if (!pager || pager.length === 0) {
        return true // ignore empty values
      }
      if (typeof pager !== 'string') {
        return this.$t('vmail.cfg.err.pager')
      }
      for (const pagerValue of pager.split(',')) {
        // naive regex to check whether value is an email or number
        if (!/^[^@\s]+@([_\d\w-]+\.)+[\w\d]{2,}$|^\d+$/.test(pagerValue.trim())) {
          return this.$t('vmail.cfg.err.pager')
        }
      }
      return true
    },
    validPin: function (pin) {
      if (typeof pin !== 'string') {
        return this.$t('vmail.cfg.err.pin')
      }
      if (this.pinRestrictions?.force_minlength) {
        const regex = new RegExp(`^[0-9]{${this.pinRestrictions.force_minlength},${this.pinRestrictions.force_maxlength}}$`)
        if (!regex.test(pin)) {
          return this.$t('vmail.cfg.err.pinln', { min: this.pinRestrictions.force_minlength, max: this.pinRestrictions.force_maxlength })
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
</style>
